import { render, staticRenderFns } from "./ClientsBlackListPage.vue?vue&type=template&id=a0b5a34a"
import script from "./ClientsBlackListPage.vue?vue&type=script&lang=js"
export * from "./ClientsBlackListPage.vue?vue&type=script&lang=js"
import style0 from "./ClientsBlackListPage.vue?vue&type=style&index=0&id=a0b5a34a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports